// src/pages/Users/Inscription/components/IdentityPanel.jsx

import React from "react";
import {
  FaBirthdayCake,
  FaCity,
  FaEnvelope,
  FaHome,
  FaIdCard,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaUser,
  FaUserShield,
  FaVenusMars,
} from "react-icons/fa";

import StepCard from "./StepCard";

function Field({
  label,
  name,
  icon,
  required,
  children,
  hint,
  error,
  className = "",
}) {
  return (
    <div className={className}>
      <label
        htmlFor={name}
        className="mb-1.5 block text-sm font-bold text-slate-700 dark:text-slate-200"
      >
        {label}
        {required ? <span className="ml-1 text-rose-500">*</span> : null}
      </label>

      <div className="relative">
        {icon ? (
          <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
            {icon}
          </span>
        ) : null}

        {children}
      </div>

      {hint ? (
        <p className="mt-1 text-xs leading-5 text-slate-500 dark:text-slate-400">
          {hint}
        </p>
      ) : null}

      {error ? (
        <p className="mt-1 text-xs font-bold leading-5 text-rose-600 dark:text-rose-300">
          {error}
        </p>
      ) : null}
    </div>
  );
}

const inputBase =
  "w-full rounded-2xl border border-slate-200 bg-white px-3 py-3 text-sm font-medium text-slate-800 outline-none transition placeholder:text-slate-400 focus:border-indigo-300 focus:ring-4 focus:ring-indigo-500/10 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:placeholder:text-slate-500";

const inputWithIcon = `${inputBase} pl-10`;

export default function IdentityPanel({
  formData,
  handleChange,
  handleDateChange,
  dateError,
  duplicateWarning,
  communes,
  communeLoading,
}) {
  return (
    <StepCard
      step="3"
      title="Coordonnées de l’adhérent"
      icon={<FaIdCard />}
      description="Renseignez l’identité, la naissance et les coordonnées de l’adhérent."
    >
      <div className="grid gap-5 lg:grid-cols-2">
        <Field
          label="Nom"
          name="nom"
          icon={<FaUser />}
          required
          error={duplicateWarning}
        >
          <input
            id="nom"
            name="nom"
            type="text"
            value={formData.nom}
            onChange={handleChange}
            required
            placeholder="DUPONT"
            className={inputWithIcon}
          />
        </Field>

        <Field label="Prénom" name="prenom" icon={<FaUser />} required>
          <input
            id="prenom"
            name="prenom"
            type="text"
            value={formData.prenom}
            onChange={handleChange}
            required
            placeholder="Lucas"
            className={inputWithIcon}
          />
        </Field>

        <Field label="Genre" name="genre" icon={<FaVenusMars />} required>
          <select
            id="genre"
            name="genre"
            value={formData.genre}
            onChange={handleChange}
            required
            className={inputWithIcon}
          >
            <option value="">Sélectionnez le genre</option>
            <option value="Masculin">Masculin</option>
            <option value="Féminin">Féminin</option>
          </select>
        </Field>

        <Field
          label="Date de naissance"
          name="date_naissance"
          icon={<FaBirthdayCake />}
          required
          error={dateError}
          hint="Format attendu : JJ/MM/AAAA."
        >
          <input
            id="date_naissance"
            name="date_naissance"
            type="text"
            inputMode="numeric"
            value={formData.date_naissance}
            onChange={handleDateChange}
            required
            placeholder="JJ/MM/AAAA"
            className={inputWithIcon}
          />
        </Field>

        <Field
          label="Lieu de naissance"
          name="lieu_naissance"
          icon={<FaMapMarkerAlt />}
          required
        >
          <input
            id="lieu_naissance"
            name="lieu_naissance"
            type="text"
            value={formData.lieu_naissance}
            onChange={handleChange}
            required
            placeholder="BORDEAUX"
            className={inputWithIcon}
          />
        </Field>

        {/* <Field
          label="Représentant légal"
          name="representant_legal"
          icon={<FaUserShield />}
          hint="À renseigner pour les mineurs."
        >
          <input
            id="representant_legal"
            name="representant_legal"
            type="text"
            value={formData.representant_legal}
            onChange={handleChange}
            placeholder="Nom du parent ou responsable légal"
            className={inputWithIcon}
          />
        </Field> */}

        <Field
          label="Nom Parent 1"
          name="nom_parent1"
          icon={<FaUserShield />}
          hint="À renseigner pour les mineurs."
        >
          <input
            id="nom_parent1"
            name="nom_parent1"
            type="text"
            value={formData.nom_parent1}
            onChange={handleChange}
            placeholder="Nom du parent ou responsable légal"
            className={inputWithIcon}
          />
        </Field>

        <Field
          label="Prénom Parent 1"
          name="prenom_parent1"
          icon={<FaUserShield />}
          hint="À renseigner pour les mineurs."
        >
          <input
            id="prenom_parent1"
            name="prenom_parent1"
            type="text"
            value={formData.prenom_parent1}
            onChange={handleChange}
            placeholder="Prénom du parent ou responsable légal"
            className={inputWithIcon}
          />
        </Field>

        <Field
          label="Profession Parent 1"
          name="prof_parent1"
          icon={<FaUserShield />}
        >
          <input
            id="prof_parent1"
            name="prof_parent1"
            type="text"
            value={formData.prof_parent1}
            onChange={handleChange}
            placeholder="facultatif : Profession du parent ou responsable légal"
            className={inputWithIcon}
          />
        </Field>

        <Field
          label="Nom Parent 2"
          name="nom_parent2"
          icon={<FaUserShield />}
          hint="À renseigner pour les mineurs."
        >
          <input
            id="nom_parent2"
            name="nom_parent2"
            type="text"
            value={formData.nom_parent2}
            onChange={handleChange}
            placeholder="Nom du parent ou responsable légal"
            className={inputWithIcon}
          />
        </Field>

        <Field
          label="Prénom Parent 2"
          name="prenom_parent2"
          icon={<FaUserShield />}
          hint="À renseigner pour les mineurs."
        >
          <input
            id="prenom_parent2"
            name="prenom_parent2"
            type="text"
            value={formData.prenom_parent2}
            onChange={handleChange}
            placeholder="Prénom du parent ou responsable légal"
            className={inputWithIcon}
          />
        </Field>

        <Field
          label="Profession Parent 2"
          name="prof_parent2"
          icon={<FaUserShield />}
        >
          <input
            id="prof_parent2"
            name="prof_parent2"
            type="text"
            value={formData.prof_parent2}
            onChange={handleChange}
            placeholder="facultatutif : Profession du parent ou responsable légal"
            className={inputWithIcon}
          />
        </Field>

        <Field
          label="Adresse"
          name="adresse"
          icon={<FaHome />}
          required
          className="lg:col-span-2"
        >
          <input
            id="adresse"
            name="adresse"
            type="text"
            value={formData.adresse}
            onChange={handleChange}
            required
            placeholder="74 rue des Écus"
            className={inputWithIcon}
          />
        </Field>

        <Field label="Code postal" name="cp" icon={<FaCity />} required>
          <input
            id="cp"
            name="cp"
            type="text"
            inputMode="numeric"
            pattern="\d{5}"
            value={formData.cp}
            onChange={handleChange}
            required
            placeholder="33110"
            className={inputWithIcon}
          />
        </Field>

        <Field
          label="Commune"
          name="commune"
          icon={<FaCity />}
          required
          hint={
            formData.cp && formData.cp.length < 5
              ? "Saisissez un code postal à 5 chiffres pour obtenir les communes."
              : ""
          }
        >
          {communes.length > 0 ? (
            <select
              id="commune"
              name="commune"
              value={formData.commune}
              onChange={handleChange}
              required
              className={inputWithIcon}
            >
              <option value="">
                {communeLoading ? "Chargement..." : "Sélectionnez votre commune"}
              </option>
              {communes.map((commune) => (
                <option key={commune} value={commune}>
                  {commune}
                </option>
              ))}
            </select>
          ) : (
            <input
              id="commune"
              name="commune"
              type="text"
              value={formData.commune}
              onChange={handleChange}
              required
              placeholder={communeLoading ? "Chargement..." : "Commune"}
              className={inputWithIcon}
            />
          )}
        </Field>

        <Field label="Téléphone" name="tel" icon={<FaPhoneAlt />} required>
          <input
            id="tel"
            name="tel"
            type="tel"
            inputMode="tel"
            value={formData.tel}
            onChange={handleChange}
            required
            placeholder="0600000000"
            className={inputWithIcon}
          />
        </Field>

        <Field
          label="Téléphone secondaire"
          name="tel_secondaire"
          icon={<FaPhoneAlt />}
        >
          <input
            id="tel_secondaire"
            name="tel_secondaire"
            type="tel"
            inputMode="tel"
            value={formData.tel_secondaire}
            onChange={handleChange}
            placeholder="Téléphone complémentaire"
            className={inputWithIcon}
          />
        </Field>

        <Field label="Email" name="email" icon={<FaEnvelope />} required>
          <input
            id="email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            required
            placeholder="adresse@email.fr"
            className={inputWithIcon}
          />
        </Field>

        <Field
          label="Email secondaire"
          name="email_secondaire"
          icon={<FaEnvelope />}
        >
          <input
            id="email_secondaire"
            name="email_secondaire"
            type="email"
            value={formData.email_secondaire}
            onChange={handleChange}
            placeholder="Email complémentaire"
            className={inputWithIcon}
          />
        </Field>
      </div>
    </StepCard>
  );
}